import React, { useState } from "react";

import { TextField, InputAdornment, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

import LocationIcon from "@mui/icons-material/LocationOn";
import { setCurrentEstateByIdThunk } from "../modules/estate/currentEstate/currentEstateSlice";

import { compose } from "recompose";
// Import HOCs directly to avoid potential circular dependency when using the
// functions barrel which itself pulls in modules that import components.
import { withCurrentEstate, withEstates } from "../functions/hocs";
import { fullAddress } from "../functions/users";

/**
 * @description Menu to select an estate and update it globally.
 * @see https://protofy.atlassian.net/browse/HAUS-454 Add filter to reduce large lists.
 */
function EstateSelect(props) {
  const { estates, currentEstate } = props;
  const [isOpen, setIsOpen] = useState(false);

  function handleChange(_, option) {
    props.dispatch(setCurrentEstateByIdThunk(option.value));
  }

  const options = estates.map((estate) => ({
    name: fullAddress(estate.address),
    value: estate.id,
  }));

  const optionsSorted = sortOptions(options);

  const currentOption = {
    name: fullAddress(currentEstate.address),
    value: currentEstate.id,
  };

  const renderInput = (params) => {
    const handleClickAdornment = () => {
      // close select if it is already open
      isOpen ? setIsOpen(false) : setIsOpen(true);
    };
    return (
      <TextField
        {...params}
        // forward the input ref explicitly to avoid findDOMNode usage inside MUI components
        inputRef={params.inputProps && params.inputProps.ref}
        InputProps={{
          ...params.InputProps,
          onClick: handleClickAdornment,
          // I found no other solution to style the component than using style directly.
          style: { color: "white" },
          startAdornment: (
            <InputAdornment position="start">
              <LocationIcon />
            </InputAdornment>
          ),
        }}
      />
    );
  };

  return estates.length === 1 ? (
    <div style={{ display: "flex", alignItems: "center" }}>
      <LocationIcon style={{ marginRight: 4 }} />
      <Typography>{fullAddress(currentEstate.address)}</Typography>
    </div>
  ) : (
    <React.Fragment>
      <Autocomplete
        id="estate-select"
        options={optionsSorted}
        getOptionLabel={(option) => option.name || ""}
        value={currentOption}
        onChange={handleChange}
        disableClearable={true}
        renderInput={renderInput}
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </React.Fragment>
  );
}

const sortOptions = (options) => {
  return options.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  });
};

export default compose(withCurrentEstate(), withEstates())(EstateSelect);
